

import { HtmlPreviewDriver } from 'src/integration/api/ui/annotators/web/HtmlPreviewDriver';
import * as NullUtil from 'src/shared/NullUtil';

import { Block, ConversionBlock, IBlockProcessor, TextBlock } from './UltraBlockInterfaces';

export class QuillEditorBlockProcessor implements IBlockProcessor<TextBlock | ConversionBlock> {

    protected readonly container: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
    }

    process(block: Block): string {
        if (block.type !== 'text' && block.type !== 'conversion' || !NullUtil.hasValue(block.id)) {
            console.warn('unexpected block type', block);
            return '';
        }
        const content =
            this.container.querySelector(`[data-draggable-id="${block.id}"]`)?.cloneNode(true) as HTMLElement ||
            this.container.querySelector(`[id="${block.id}-rte"]`)?.cloneNode(true) as HTMLElement;
        if (!content) {
            console.warn(`Block with id ${block.id} not found`);
            return '';
        }

        Object.values(HtmlPreviewDriver.customAttributes).forEach((key) => {
            content.querySelectorAll(`[${key}]`).forEach((el) => el.removeAttribute(key));
        });

        const tag = NullUtil.orElse(content.tagName, 'div').toLowerCase();
        return `<${tag} id="${block.id}">${content.innerHTML}</${tag}>`;
    }
}
